import { TourStep } from '../../models/tour.model';

export const DASHBOARD_TOUR: TourStep[] = [
  {
    title: 'Welcome to Semeris Docs',
    intro: `
              <p><b>Semeris Docs</b> offers a novel way to engage with extensive collections of complex legal documents.</p>
              <p>Whether you are</p>
              <ul>
                  <li>researching deal documents,</li>
                  <li>comparing deal summaries,</li>
                  <li>blacklining documents,</li>
                  <li>benchmarking against the market or</li>
                  <li>taking collaborative notes,</li>
              </ul> 
              <p>numerous features expedite your tasks.</p>
              <p>Our rapid guided tours walk you through features <b>step by step</b>.</p>
              <p><i>This initial tour introduces basic concepts.</i></p>
              `,
  },
  {
    title: 'Semeris Docs Asset Classes',
    element: 'semeris-meta-data-stats',
    intro: `
              <p>Semeris Docs supports a <b>range of asset classes</b> including US CLOs, EU CLOs, High-Yield Bonds, and others, accessible based on your permissions.</p>
              <p>This section offers a snapshot of <b>datapoints, topics, and checklists</b> pertinent to your <b>selected asset class(es)</b>.</p>
              <p>The <b>Terminology 101</b> link in the corner explains these basic concepts.</p>
              <p>To <b>explore lists</b>, each box can be clicked.</p>
              `,
  },
  {
    title: 'Choose Your Asset Class',
    element: 'semeris-asset-selector',
    intro: `
              <p>You can use this dropdown to specify the asset class or classes of interest.</p>
              <p>It refines your view, showcasing <b>only relevant deals and concepts</b>.</p>
              `,
  },
  {
    title: 'Sidebar Menu',
    element: '.sidenav-content',
    intro: `
            <p>The Semeris Docs sidebar provides direct access to key features.</p>
            <ul>
              <li><b>FIND AND REVIEW</b> - Access Deals, Text Search, and more.</li>
              <li><b>COMPARE</b> - Use Deal Compare and Market Compare.</li>
              <li><b>COLLABORATE</b> - Work with Notes and Labels.</li>
              <li><b>BUILD</b> - Set up your own Checklists and more.</li>
              <li><b>UPLOAD</b> - Submit your documents.</li>
            </ul>
            <p>Menu items might vary based on your permissions.</p>
            `,
  },
  {
    title: 'Hiding the Sidebar',
    element: '.sidenav-extender button span',
    intro: `
                <p>Sometimes you will need more screen space.</p>
                <p>Clicking this left arrow <i class="material-icons">chevron_left</i> collapses the sidebar.</p>
              `,
  },
  {
    title: 'Start Your Searches Here',
    element: 'semeris-search-box',
    intro: `
                <p>Toolbar Search is always <b>a good starting point</b> to find information.</p>
                <p>You can find everything, from <b>deal names</b> and <b>tickers</b> to <b>various topics</b> and <b>defined terms</b>.</p>
                <p>A tip: <b>Pause briefly</b> after typing your query, and the toolbar will offer suggestions.</p>
                <p>You can even search in documents: just <b>type and press Enter</b>.</p>
              `,
  },
  {
    title: 'Meet Semeris X-Ray',
    element: 'semeris-xray-control',
    intro: `
                <p>Our unique Semeris X-Ray technology <b>makes reading legal text easier</b> with just a click.</p>
                <p>Consider this text as an example:</p>
                <img src="assets/img/tour-xray-original.png" width="560px" alt="Semeris X-Ray original" />
              `,
  },
  {
    title: 'Meet Semeris X-Ray',
    element: 'semeris-xray-control',
    intro: `
                <p>With Semeris X-Ray, the text <b>transforms</b> into:</p>
                <img src="assets/img/tour-xray-example.png" width="560px" alt="Semeris X-Ray'd" />
                <ul>
                  <li><i class="material-icons">wrap_text</i> <b>Reflow</b> - Breaks down dense paragraphs.</li>
                  <li><i class="material-icons">alt_route</i> <b>Key Legal Logic</b> - Marks key terms in light yellow.</li>
                  <li><i class="material-icons">pin</i> <b>Facts</b> - Highlights data in green and associated logic in light blue.</li>
                </ul>
              `,
  },
  {
    title: 'Quick Help Access',
    element: 'semeris-help-icon',
    intro: `
            <p>Have you noticed the <i class="material-icons">help_outline</i> help icon?</p>
            <p>Click it on any screen for instant, relevant help.</p>
            `,
  },
  {
    title: 'Discover Semeris Docs',
    element: 'semeris-feature-discovery',
    intro: `
            <p>Complementing our guided tours, this card helps you <b>track your progress</b> in discovering Semeris Docs.</p>
            <p>Click on a feature to access <b>step-by-step instructions</b> that guide you in using it.</p>
            <p>Features you have tried at least once will be <b>automatically marked as completed</b>.</p>
            `,
  },
  {
    title: 'Continue your Journey',
    position: 'left',
    element: 'semeris-guided-tour-card',
    intro: `
            <p>As you progress, <b>completed tours</b> and <b>discovered features</b> are marked with a <i class="material-icons">check_box</i> checkmark, reflecting your self-paced journey.</p>
            <ul>
              <li><b>Guided Tours</b> - Begin with the basics on the Dashboard and explore further in the help sidebar.</li>
              <li><b>Discover Semeris Docs</b> - Click on features that pique your interest to learn how they work.</li>
            </ul>
           `,
  },
];
